import React from "react";
import { BoxIcon } from "lucide-react";
interface MedallionProps {
  icon: BoxIcon;
  className?: string;
}
export function Medallion({
  icon: Icon,
  className = ''
}: MedallionProps) {
  return <span className={`inline-flex h-16 w-16 items-center justify-center rounded-full border border-orange-400/40 bg-orange-400/10 [.chalk_&]:border-orange-600/40 [.chalk_&]:bg-orange-600/10 ${className}`} aria-hidden="true" data-id="element-148" data-mp="1zbqyo7zazzuw">
      <Icon className="h-7 w-7 text-orange-400 [.chalk_&]:text-orange-600" strokeWidth={1.6} data-id="element-149" data-mp="28c70ze4b90y6" />
    </span>;
}